export type ElecBreakdownCatID =
  | 'alwaysOn'
  | 'lighting'
  | 'other'
  | 'cooking'
  | 'entertainment'
  | 'refrigeration'
  | 'washing'
  | 'waterHeating'
  | 'heating'
  | 'ev';

export type GasBreakdownCatID = 'waterHeating' | 'cooking' | 'heating';

export type AnyBreakdownCatID = ElecBreakdownCatID | GasBreakdownCatID;

export enum EnergyInsightsPageName {
  Hub = 'Energy Insights - Hub',
  BillBreakdown = 'Energy Insights - Bill Breakdown',
  CarbonIntensity = 'Energy Insights - Carbon Intensity',
  Terms = 'Energy Insights - Terms',
}
